import { Link, Redirect } from "react-router-dom";
import styled, { css } from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import { Toggler } from "../../header/styles/Header";

export const MainUtils = styled.div<{ open: boolean }>`
  ${tw`m-auto`};
  max-width: 1200px;
  transition: all 0.3s ease-in-out;
  position: relative;

  ${({ open }) => open && "opacity: 0;"}
`;

export const ContainerUtils = styled.div`
  ${tw` py-0 px-10 w-full`};

  ${media.desktop} {
    ${tw`p-0`}
  }
`;

export const RowUtils = styled.div<{ fin: boolean }>`
  ${tw`flex flex-wrap`};

  ${({ fin }) => fin && "justify-content: flex-end;"}
`;

export const ImageBoxUtils = styled.div``;

export const Button = css`
  ${tw`
    leading-6 bg-white25 py-2.5 px-7 inline-block rounded-full no-underline text-primaryClr font-medium capitalize border border-solid
    border-white40 text-base cursor-pointer select-none relative overflow-hidden align-middle
  `};

  transition: width 0.3s ease;
  margin: 0 15px 15px 0;

  &:hover {
    color: white;
  }

  &::before {
    content: "";
    z-index: -1;
    transition: width 0.3s ease;

    ${tw`absolute left-0 top-0 h-full w-0 bg-primaryClr `};
  }

  &:hover::before {
    width: 100%;
  }
`;

export const BtnUtils = styled.button`
  ${Button}
`;

export const ButtonUtils = styled(Link)`
  ${Button}
`;

export const RedirectUtils = styled.a`
  ${Button}
`;

export const HeaderUtils = styled.div`
  ${tw`py-0 px-4 w-full text-center mb-10`};
`;

export const TitleUtils = styled.h2`
  ${tw`text-4xl capitalize `};

  ${media.phone} {
    ${tw`text-3xl`}
  }
`;
